import React, { ReactNode, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import { FormComponent } from 'components';
import { useInfiniteScroll } from 'hooks';
import { USER_MENU_URL } from 'data/menu';
import { UserQuery } from 'queries';
import { SearchUserFilterType } from 'types';
import { getUserStatus } from '../utils/status';
import * as M from 'styles/mobile';
import * as S from './style';

const getPhoneLast4 = (phone?: string) =>
  (phone ?? '').replace(/\D/g, '').slice(-4);

interface Props {
  title?: ReactNode;
}

function MobileList({ title }: Props) {
  const navigate = useNavigate();
  const [filter, setFilter] = useState<SearchUserFilterType>({});

  const { data, hasNextPage, isFetchingNextPage, fetchNextPage, isLoading } =
    UserQuery.useGetInfinite(filter);
  const sentinelRef = useInfiniteScroll({
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  const users = data ?? [];

  return (
    <>
      <div css={M.stickyTop}>
        {title}
        <FormComponent.Form
          submit={(d: SearchUserFilterType) =>
            setFilter({ name: d.name || undefined })
          }
        >
          <FormComponent.SearchInput
            name="name"
            placeholder="이름으로 검색해주세요"
          />
        </FormComponent.Form>
      </div>
      <div css={M.list}>
        {users.map(({ id, name, phone, status, signUpDate }) => {
          const last4 = getPhoneLast4(phone);
          return (
            <button
              key={id}
              type="button"
              css={M.listItem}
              onClick={() => navigate(`${USER_MENU_URL.회원목록}/${id}`)}
            >
              <div css={M.listRow}>
                <p css={S.name}>
                  {name}
                  {last4 && <span>({last4})</span>}
                </p>
                <span css={M.listDate}>
                  {dayjs(signUpDate).format('YYYY-MM-DD')}
                </span>
              </div>
              <span css={S.status(status !== 'NORMAL')}>
                {getUserStatus(status)}
              </span>
            </button>
          );
        })}
        {!isLoading && users.length === 0 && (
          <p css={M.empty}>검색 결과가 없습니다</p>
        )}
        {isFetchingNextPage && <p css={M.empty}>불러오는 중...</p>}
      </div>
      <div ref={sentinelRef} css={M.sentinel} />
    </>
  );
}

export default MobileList;
